import React from "react";

const HistoryCard = ({ historyItem, t }) => {
  return (
    <div
      className="note-card bg-white border border-gray-300 rounded-15 p-4 mb-3 shadow-sm position-relative overflow-hidden"
      style={{
        transition: "all 0.3s ease-in-out",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = "0 8px 25px rgba(0, 0, 0, 0.1)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 1px 6px rgba(62, 96, 147, 0.18)";
      }}
    >
      <div className="d-flex align-items-start justify-content-between mb-3">
        <div className="flex-fill">
          <div className="d-flex align-items-center gap-2 mb-2">
            <div
              className="p-2 bg-white border border-primary rounded-circle d-flex align-items-center justify-content-center"
              style={{ width: "30px", height: "30px" }}
            >
              <span className="material-symbols-outlined fs-sm text-primary icon-fill">
                event
              </span>
            </div>
            <h6 className="fw-bold mb-0 text-dark">
              {t("Update on")} {historyItem.dateofchange}
            </h6>
          </div>
        </div>
      </div>
      <div className="note-content">
        <div className="d-flex align-items-center gap-2 mb-2">
          <span className="material-symbols-outlined fs-sm text-muted">
            person
          </span>
          <small className="text-muted fw-semibold">
            {t("Updated By")} : {historyItem.updatedbyname || "N/A"}
          </small>
        </div>
        <p className="text-dark lh-base mb-0" style={{ fontSize: "0.95rem" }}>
          <span className="material-symbols-outlined fs-sm text-muted me-2">
            edit
          </span>
          <strong>{t("Updated Fields")} : </strong>{" "}
          {historyItem.changedfieldnames || "N/A"}
        </p>
      </div>
    </div>
  );
};

export default HistoryCard;
